import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.textMid};
  padding: 20px 15px;
`;

export default Container;
